// extracted by mini-css-extract-plugin
export default {"ProductDescription":"_ProductDescription--DMrJJ","Expanded":"_Expanded--u7lzk","ReadOnly":"_ReadOnly--mpKWu"};